import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { FC } from 'react';

interface ConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void; // 確定ボタンの処理を外部から渡せる
    title: string;
    message: string;
}

/**
 * 確認ボタン
 * @param param0 
 * @returns 
 */
const ConfirmDialog: FC<ConfirmDialogProps> = ({ open, onClose, onConfirm, title, message }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <p>{message}</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>いいえ</Button>
                <Button onClick={onConfirm} autoFocus>はい</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;